module.exports = __webpack_public_path__ + "img/build1.29f176e5.jpg";